<template>
    <teleport to="#modal">
        <Loading
            :visible="loading ||listaProgettiBu.loading||listaMyProgetti.loading"
        >
        </Loading>
        <ModalProgetto @saved="onAddProgetto" v-model:visible="visible"></ModalProgetto>
        <ModalProjectFilter class="z-50"
            v-model:visible="filtri_visible"
            v-model:data_inizio_dal="filtri.data_inizio_dal"
            v-model:data_inizio_al="filtri.data_inizio_al"
            v-model:data_fine_dal="filtri.data_fine_dal"
            v-model:data_fine_al="filtri.data_fine_al"
            v-model:cliente="filtri.cliente"
            v-model:azienda_gruppo="filtri.azienda_gruppo"
            v-model:stato="filtri.stato"
            :progetti="true"
        ></ModalProjectFilter>
    </teleport>
    <div class="m-auto px-8">
        <div class="m-auto">
            <div class="flex justify-between items-center pt-10">
                <div class="flex items-center">

                    <Switcher v-model="tab_show" :options="['I miei progetti', 'Tutti i progetti']"
                              class="grow whitespace-nowrap mr-3"></Switcher>

                    <div class="flex flex-col w-[400px]">
                        <Field :labelVisible="false"
                               v-model="listaMyProgetti.search"
                               placeholder="Cerca nei progetti"></Field>
                    </div>

<!--                    <div v-show="tab_show" class="flex flex-col w-[400px]">-->
<!--                        <Field :labelVisible="false" @update:modelValue="listaProgettiBu.debounceSearch"-->
<!--                               v-model="listaProgettiBu.search"-->
<!--                               placeholder="Cerca nei progetti"></Field>-->
<!--                    </div>-->
                    <div class="flex">
                        <i @click="filtri_visible = !filtri_visible"
                           class="pl-2 fa text-xl icon-filtri hover:text-next-orange cursor-pointer"></i>
                        <p v-show="hasFiltri" class="cursor-pointer pl-3 font-bold text-next-atp" @click="svuotaFiltri">Svuota filtri</p>
                    </div>
                </div>

                <NextButton variant="primary" @click="visible=true"
                            class="w-44 ml-3 py-2 px-4 m-0">
                    + Aggiungi
                </NextButton>
            </div>
            <!--      <Grid :cols="cols" :rows="rows"></Grid>-->
            <div v-if="!tab_show">
                <div class="flex justify-end pt-2">
                    <Paginator class="" :pagination="listaMyProgetti.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5"
                               v-model:cols="progettiCols"
                               :rows="listaMyProgetti.rows" @order-update="listaMyProgetti.updateCols">
                        <template v-for="(c, j) in listaMyProgetti.rows" :key="j" v-slot:[`td_${j}_0`]="context">
                            <div v-show="context.context.row.sottoprogetti.length != 0"
                                 class="table-curtain-icon absolute top-0 bottom-0 flex items-center px-3 group"
                                 :class="{open: c.expanded}" @click="c.expanded=!c.expanded">
                                <i class="fas fa-caret-right text-xl group-hover:text-next-orange duration-300 ease-in-out"></i>
                            </div>
                            {{ context.context.row.id_gamma }}
                        </template>
                        <template v-for="(c, j) in listaMyProgetti.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>
                        <template v-for="(c, j) in listaMyProgetti.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ $filters.toDate(context.context.row.data_fine) }}
                        </template>
                        <template v-for="(c, j) in listaMyProgetti.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                            {{ $filters.toEuroCurrency(context.context.row.budget) }}
                        </template>
                        <template v-for="(c, j) in listaMyProgetti.rows" :key="j" v-slot:[`td_${j}_8`]="context">
                            <router-link :to="{name:'DettaglioProgetto', params:{id:context.context.row.id}}"
                                         class="text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                        </template>
                        <template v-for="(c, j) in listaMyProgetti.rows" :key="j" v-slot:[`td_${j}_9`]>
                            <TabellaContextMenu
                                menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                                buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                                :context="c"
                                :id="j"
                                teleport_to="#modal"
                                :cmOpener="cmOpener"
                            >
                                <router-link :to="{name:'Attivita', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Attività
                                </router-link>
                                <router-link :to="{name:'Contatti', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Contatti
                                </router-link>
                            </TabellaContextMenu>

                        </template>

                        <template v-for="(c, i) in listaMyProgetti.rows" :key="i" v-slot:[`td_child_${i}`]="context">
                            <template v-if="c.expanded">
                                <tr v-for="(cc, j) in context.context.row.sottoprogetti_from_view" :key="j" class="h-11.5 text-sm">
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">{{
                                            cc.cod_nodo
                                        }}
                                    </td>
                                    <td colspan="2" class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">{{
                                            cc.titolo
                                        }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                        {{ context.context.row.denominazione }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                        {{ $filters.toDate(cc.data_inizio) }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                        {{ $filters.toDate(cc.data_fine) }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right">
                                        {{ $filters.toEuroCurrency(cc.budget) }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right">
                                        {{ cc.stato_next_descrizione }}
                                    </td>
                                    <td class="px-2 bg-next-gray-md-dark relative hover:bg-next-orange hover:text-white">
                                        <router-link :to="{name:'DettaglioSottoProgetto', params:{id:cc.id}}"
                                                     class="text-center inset-0 absolute flex items-center justify-center">
                                            <i class="icon-chevron_destra"></i></router-link>
                                    </td>
                                </tr>
                            </template>

                        </template>
                    </NextTable>
                </div>
                <InfiniteLoading @infinite="listaMyProgetti.fetchNextPage"
                                 :identifier="listaMyProgetti.infiniteIdentifier" style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri progetti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else>
                <div class="flex justify-end pt-2">
                    <Paginator class="" :pagination="listaProgettiBu.paginate"></Paginator>
                </div>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5"
                               v-model:cols="progettiCols"
                               :rows="listaProgettiBu.rows" @order-update="listaProgettiBu.updateCols">
                        <template v-for="(c, j) in listaProgettiBu.rows" :key="j" v-slot:[`td_${j}_0`]="context">
                            <div v-if="context.context.row.sottoprogetti.length != 0"
                                 class="table-curtain-icon absolute top-0 bottom-0 flex items-center px-3 group"
                                 :class="{open: c.expanded}" @click="c.expanded=!c.expanded">
                                <i class="fas fa-caret-right text-xl group-hover:text-next-orange duration-300 ease-in-out"></i>
                            </div>
                            {{ context.context.row.id_gamma }}
                        </template>
                        <template v-for="(c, j) in listaProgettiBu.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>
                        <template v-for="(c, j) in listaProgettiBu.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                            {{ $filters.toDate(context.context.row.data_fine) }}
                        </template>
                        <template v-for="(c, j) in listaProgettiBu.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                            {{ $filters.toEuroCurrency(context.context.row.budget) }}
                        </template>
                        <template v-for="(c, j) in listaProgettiBu.rows" :key="j" v-slot:[`td_${j}_8`]="context">
                            <router-link :to="{name:'DettaglioProgetto', params:{id:context.context.row.id}}"
                                         class="block text-center inset-0 absolute flex items-center justify-center"><i
                                class="icon-chevron_destra"></i></router-link>
                        </template>
                        <template v-for="(c, j) in listaProgettiBu.rows" :key="j" v-slot:[`td_${j}_9`]>
                            <TabellaContextMenu
                                menuClass="shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white"
                                buttonClass="bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange"
                                :context="c"
                                :id="j"
                                teleport_to="#modal"
                                :cmOpener="cmOpener"
                            >
                                <router-link :to="{name:'Attivita', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Attività
                                </router-link>
                                <router-link :to="{name:'Contatti', params: {id:c.id}}"
                                             class="hover:text-next-neu mb-2">Contatti
                                </router-link>
                            </TabellaContextMenu>
                        </template>

                        <template v-for="(c, i) in listaProgettiBu.rows" :key="i" v-slot:[`td_child_${i}`]="context">
                            <template v-if="c.expanded">
                                <tr v-for="(cc, j) in context.context.row.sottoprogetti_from_view" :key="j" class="h-11.5 text-sm">
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">{{
                                            cc.cod_nodo
                                        }}
                                    </td>
                                    <td colspan="2" class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">{{
                                            cc.titolo
                                        }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                        {{ context.context.row.denominazione }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                        {{ $filters.toDate(cc.data_inizio) }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                        {{ $filters.toDate(cc.data_fine) }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right">
                                        {{ $filters.toEuroCurrency(cc.budget) }}
                                    </td>
                                    <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark text-right">
                                        {{ cc.stato_next_descrizione }}
                                    </td>
                                    <td class="px-2 bg-next-gray-md-dark relative hover:bg-next-orange hover:text-white">
                                        <router-link :to="{name:'DettaglioSottoProgetto', params:{id:cc.id}}"
                                                     class="block text-center inset-0 absolute flex items-center justify-center">
                                            <i class="icon-chevron_destra"></i></router-link>
                                    </td>
                                </tr>
                            </template>

                        </template>
                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaProgettiBu.fetchNextPage"
                                 :identifier="listaProgettiBu.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri progetti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import {Paths} from "@/types";
import {lista_clienti} from "@/BreadcrumbsPath";
import InfiniteLoading from "v3-infinite-loading";
import ConfermaModal from "@/components/ConfermaModal.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import TopbarProgetti from "@/components/TopbarProgetti.vue";
import ModalProgetto from "@/components/ModalProgetto.vue";
import progettiManager from "../api/Progetti";
import Switcher from "@/components/Switcher.vue";
import NextButton from "@/components/NextButton.vue";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Lista from '@/setup/ListaCerca';
import Field from "@/components/Field.vue";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import ModalProjectFilter from "@/components/ModalProjectFilter.vue";

@Options({
    name: 'ListaProgetti',
    components: {
        ModalProjectFilter,
        Field,
        NextButton,
        Switcher,
        TopbarProgetti,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ConfermaModal,
        ContextMenu,
        Loading,
        TabellaContextMenu,
        ModalProgetto
    },
    props: {}
})
export default class ListaProgetti extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    tab_show = 0
    loading = false
    visible = false
    cm_visible = -1
    filtri_visible = false

    listaProgettiBu: any = setup(() => Lista(progettiManager, this.progettiCols, progettiManager.progetti))

    listaMyProgetti: any = setup(() => Lista(progettiManager, this.progettiCols, progettiManager.myProgetti));

    get getBreadcrumbsPath(): Paths[] {
        return lista_clienti
    }

    filtri = {
        anno: '',
        data_inizio_dal: '',
        data_inizio_al: '',
        data_fine_dal: '',
        data_fine_al: '',
        cliente: '',
        azienda_gruppo: '',
        bu: '',
        stato: '',
    }

    svuotaFiltri() {
        this.filtri.anno = ''
        this.filtri.data_inizio_dal = ''
        this.filtri.data_inizio_al = ''
        this.filtri.data_fine_dal = ''
        this.filtri.data_fine_al = ''
        this.filtri.cliente = ''
        this.filtri.azienda_gruppo = ''
        this.filtri.bu = ''
        this.filtri.stato = ''
    }

    get hasFiltri() {
        return this.filtri.anno != '' ||
            this.filtri.data_inizio_dal != '' ||
            this.filtri.data_inizio_al != '' ||
            this.filtri.data_fine_dal != '' ||
            this.filtri.data_fine_al != '' ||
            this.filtri.cliente != '' ||
            this.filtri.azienda_gruppo != '' ||
            this.filtri.bu != '' ||
            this.filtri.stato != ''
    }

    @Watch('listaMyProgetti.search')
    setFilter(new_val: any, old_val: any) {
        if(!old_val.length && this.tab_show == 0){
            this.tab_show = 1
        }
        this.listaMyProgetti.search = new_val
        this.listaProgettiBu.search = new_val
        this.listaMyProgetti.debounceSearch()
        this.listaProgettiBu.debounceSearch()
    }

    @Watch('filtri', {deep: true})
    filtriChange(new_value: any) {
        this.listaProgettiBu.apiParams = this.filtri
        this.listaMyProgetti.apiParams = this.filtri
        this.resetView()
    }

    mounted() {
        this.listaProgettiBu.sort = '-data_inizio'
        this.listaMyProgetti.sort = '-data_inizio'
        this.resetView()
    }

    resetView() {
        this.listaProgettiBu.reset()
        this.listaMyProgetti.reset()
    }

    onAddProgetto(data: any) {
        this.visible = false
        //@ts-ignore
        this.$router.push({name: 'DettaglioProgetto', params: {id: data.id}})
    }

    budgetPreventivo(row: any) {
        let i = -row.sottoprogetti.reduce((acc: number, curr: any) => {
            return acc - (curr.budget_preventivo ?? 0)
        }, 0)
        return i
    }

    progettiCols: any[] = [
        // {
        //     name: 'ID',
        //     prop: 'id',
        //     orderable: true,
        //     class: 'text-left min-w-200 w-40 whitespace-nowrap',
        //     td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
        //     resizable: false
        // },
        {
            name: 'ID progetto',
            prop: 'id_gamma',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Nome progetto',
            prop: 'titolo',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Az. gruppo',
            prop: 'azienda_gruppo_nome',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Committente',
            prop: 'denominazione',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Data inizio',
            prop: 'data_inizio',
            order: 2,
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Data fine',
            prop: 'data_fine',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Budget aper.',
            prop: 'budget',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: true
        },
        {
            name: 'Stato',
            prop: 'stato',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark text-right',
            resizable: true
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },

    ]
}

</script>


<style lang="scss">

</style>
